<template>
    <div style="background-color: #fafafa;">
        <van-list v-model="loading" :finished="finished" @load="onload" finished-text="没有更多了">
            <div v-for="form in list" class="card" :key="form.uuid" @click="openForm(form.formDataId,form.workflowTemplate)">
                <table class="layout">
                    <tr>
                        <td colspan="2" >
                            <div class="header">
                                <span class="title">{{form.formName+"("+form.serialNumber+")"}}</span>
                                <span class="status">{{form.creatorName}}</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </van-list>
    </div>
</template>

<script>
    import {Button, List, Panel, PullRefresh, Search, Tab} from 'vant';
    import userInfo from '../../store/userInfo';
    import formService from "../../service/formService";

    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0
            }
        },
        store: userInfo,
        components: {
            [Tab.name]: Tab,
            [Button.name]: Button,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [PullRefresh.name]: PullRefresh
        },
        created: async function () {

        },
        methods: {
            async onload (){
                this.pageIndex++;
                let resp = await formService.getReceiveList(this.pageIndex);
                if (resp.data.Status === "1"){
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [...this.list, ...resp.data.Data.data];
                    this.finished = resp.data.Data.total <= this.list.length;
                }
            },
            openForm(id,workflowTemplate) {
                // this.$router.push("/sinochem/formLogin?workflowTemplateId="+workflowTemplate+"&id="+id);
                this.$router.push("/app/forms/"+workflowTemplate+"/"+id);
                // this.$router.push("/customer");
            }
        }
    };
</script>

